<template>
  <div class='job-detail'>

    <navigator class='header' title="人力资源平台" :routePath='"/humanResource/serviceList"'></navigator>

    <Job :job='job'></Job>

    <mt-cell class='job_desc' title="职责描述"></mt-cell>

    <div class='rich_text' v-html='job.content'></div>

    <mt-cell class='job_desc' title="公司介绍"></mt-cell>

    <div class='rich_text' v-html='job.corpProfile'></div>

    <div class='footer'>
      <mt-button @click='apply'>投递意向</mt-button>
    </div>

    <van-dialog v-model="applyFlag" title='附言' show-cancel-button @cancel='cancel' @confirm='confirm'>
      <van-field v-model="applyMsg" label="附言" placeholder="请输入附言"/>
    </van-dialog>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Job from './ServiceItem';
import { Toast } from 'vant';

export default {
  data() {
    return {
      jobId: '',
      job: {},

      errorMsg: '申请成功，等待企业与您联系！',
      duration: 1000,
      position: '',
      applyFlag: false,
      applyMsg: '',
    };
  },
  methods: {

    apply() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {
        this.applyFlag = true;
      }
    },
    cancel() {
      this.applyMsg = '';
    },
    confirm() {
      if (!this.applyMsg) {
        this.errorMsg = '请填写附言'
        Toast.fail({ duration: this.duration, message:  this.errorMsg});
        this.applyFlag = true;
        return;
      }
      this.submitRequest();
    },

    submitRequest() {
      this.$http.post(`${this.URL_PREFIX}/app/added/hr/service/order`, {
        parkId: this.currentParkId,
        remark: this.applyMsg,
        serviceId: this.job.id,
        qrId: this.$route.query.bindQr==1 ? (this.qrcodeServiceInfo.qrId || undefined) : undefined,
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;

        this.applyMsg = '';
        if (res.resCode !== '10000') {
          this.errorMsg = res.resDesc;
          Toast.fail({ duration: this.duration, message:  this.errorMsg});
        } else {
          this.errorMsg = '申请成功，等待企业与您联系！';
          Toast.success({ duration: this.duration, message:  this.errorMsg});
        }
      });
    },
    getJobDetail() {
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/service/info/detail`, {
        id: this.jobId,
      }, {
        headers: { token: this.token, }
      }).then((response) => {
        const res = response.data;
        this.job = res.resData;
      });
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'qrcodeServiceInfo']),
  },
  components: { Job },
  created() {
    this.jobId = this.$route.params.id;
    this.getJobDetail();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
@import "~@css/human_resource.scss";
.job-detail {
  .header{
    margin-bottom: .133333rem;
  }
  .job_desc{
    margin-bottom: .026667rem;
    font-size: .453333rem;
    font-weight: 600;
    color: rgb(51, 51, 51);
  }

  .rich_text{
    padding: .32rem;
    margin-bottom: .133333rem;
    background: #fff;
  }

  .footer{
    padding: px2rem(16) px2rem(24);
    background-color: #f5f5f5;
    margin-top: .4rem;
    box-sizing: border-box;
    width: 100%;
    .mint-button{
      width: 100%;
      height: 1.04rem;
      background: $color-main;
      color: #fff;
      font-size: .48rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/humanResource/components/ServiceDetail.vue